import React from 'react';
import {withRouter} from 'react-router-dom';

@withRouter
export default class PurchaseItem extends React.Component {

  handleClick = () => {
    console.log(this.props.data)
    if (this.props.location.pathname == '/aci/purchased')
     {
      this.props.history.push('/aci/details/' + this.props.data.id)
      } else if (this.props.location.pathname == '/iacp/purchased') {
        this.props.history.push('/iacp/details/' + this.props.data.id)
      } else if(this.props.data.workshop_type === 'live') {
        this.props.history.push(`/details/webinar/${this.props.data.id}`);
      } else if(this.props.data.workshop_type === 'group_supervision') {
        this.props.history.push(`/details/group_supervision/${this.props.data.id}`);
      } else if(this.props.data.workshop_type === 'public_workshop') {
        this.props.history.push(`/details/public_workshops/${this.props.data.id}`);
      } else {
        this.props.history.push(`/details/online/${this.props.data.id}`);
      }
  };

  render(){
    return(
      <div className="col-12" onClick={this.handleClick}>
        <div className="card regular purchases">
          <div className="purchases-content">
            <div className="card-footer">
              <div className="card-footer-top">
                <p className="card-title">{this.props.data.title}</p>
              </div>
              <div className="card-footer-bottom"/>
            </div>

            <ul className="card-info purchased-list-info">
              <li>

                  <ul className="suitableFor">
                    <li key="wdw"> <p className="card-info-title">Suitable for: </p></li>
                    {this.props.data.target_audience.map( (el,i) =>
                      <li key={i}><span style={{color: COLOR, marginLeft: 1}}>{el}</span></li>
                    )}
                  </ul>

              </li>
              <li>
                <p className="card-info-title" key="modules">
                  Modules:
                  <span className="card-info-sub" style={{color: COLOR}}>
                    {this.props.data.modules_count || CPD_FALSE}
                  </span>
                </p>
              </li>
              <li>
                <p className="card-info-title" key="info">
                  CPD Hours:
                  <span className="card-info-sub">
                    {this.props.data.how_many_hours || 'Check with provider'}
                  </span>
                </p>
              </li>
            </ul>


          </div>
          <div className="purchases-price">
            <p className="caption">purchased:</p>
            <p className="date">{this.props.data.purchased_at}</p>
            <p className="price"><span className="currency euro"/>{this.props.data.cost}</p>
            <p className={`status ${this.props.data.status} `}>{this.props.data.status}</p>
          </div>
        </div>
      </div>
    )
  }
}
const COLOR = '#039ee5';


const CPD_FALSE = (<svg  width="10" height="9">
  <path fill="#FF524F" fillRule="evenodd" d="M2.292.758L.947 2.104l2.7 2.7-2.7 2.7L2.292 8.85l2.701-2.7 2.7 2.7 1.346-1.346-2.701-2.7 2.701-2.7L7.693.758l-2.7 2.701L2.292.758"/>
</svg>);



// WEBPACK FOOTER //
// ./src/components/purchased/PurchaseItem.jsx